import React, { useEffect, useState } from 'react';
import { Select, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { listerBanques } from '../services/attestationsService';
import { filtreSansAccents } from '../utils/rechercheTexte';

/**
 * Banque d'un chèque, choisie dans le référentiel (Paramètres › Banques).
 *
 * La banque se saisissait au clavier : deux orthographes pour le même établissement, et
 * rien à recouper. La valeur reste le NOM de la banque - c'est ce que `banque_cheque` et
 * `banque_emettrice` stockent - pour ne rien changer aux règlements déjà enregistrés.
 *
 * Référentiel vide : on retombe sur la saisie libre plutôt que de bloquer un règlement.
 */
export default function SelectBanque({ value, onChange, placeholder, ...reste }) {
  const { t } = useTranslation('commun');
  const [banques, setBanques] = useState(null);

  useEffect(() => {
    let annule = false;
    listerBanques()
      .then((l) => { if (!annule) setBanques(Array.isArray(l) ? l : []); })
      .catch(() => { if (!annule) setBanques([]); });
    return () => { annule = true; };
  }, []);

  if (banques && banques.length === 0) {
    return (
      <Input
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={t('selectBanque.nomSaisieLibre')}
        maxLength={150}
        {...reste}
      />
    );
  }

  return (
    <Select
      showSearch
      filterOption={filtreSansAccents}
      allowClear
      loading={banques === null}
      value={value || undefined}
      onChange={onChange}
      placeholder={placeholder === undefined ? t('selectBanque.selectionner') : placeholder}
      optionFilterProp="label"
      options={(banques || []).map((b) => ({ value: b.nom, label: b.nom }))}
      {...reste}
    />
  );
}
